<template>
  <head>
    <title>
      {{ id == 0 ? $t("dashboard.AddPlans") : $t("dashboard.EditPlan") }}
    </title>
  </head>
  <div class="add-plan">
    <SideBar>
      <div
        class="container bg-light h-100 d-flex justify-content-center align-items-start py-5"
        style="overflow-y: scroll"
      >
        <CardComponent
          :title="id == 0 ? $t('dashboard.AddPlans') : $t('dashboard.EditPlan')"
        >
          <form
            class="w-100 d-flex justify-content-center align-items-center"
            v-on:submit.prevent="id == 0 ? addPlan() : editPlan()"
          >
            <div class="d-block w-100">
              <div class="my-3">
                <input
                  type="text"
                  v-model="bedroomsAR"
                  :placeholder="$t('dashboard.bedroomsAR')"
                  class="my-inp w-50"
                  style="border: 1px solid black"
                />
              </div>
              <div class="my-3">
                <input
                  type="text"
                  v-model="bedroomsEN"
                  :placeholder="$t('dashboard.bedroomsEN')"
                  class="my-inp w-50"
                  style="border: 1px solid black"
                />
              </div>
              <div class="my-3">
                <input
                  type="text"
                  v-model="spaceAR"
                  :placeholder="$t('dashboard.spaceAR')"
                  class="my-inp w-50"
                  style="border: 1px solid black"
                />
              </div>
              <div class="my-3">
                <input
                  type="text"
                  v-model="spaceEN"
                  :placeholder="$t('dashboard.spaceEN')"
                  class="my-inp w-50"
                  style="border: 1px solid black"
                />
              </div>
              <!-- <div class="my-3">
                <input
                  type="number"
                  min="1"
                  v-model="rentStart"
                  :placeholder="$t('dashboard.rentStart')"
                  class="my-inp w-50"
                  style="border: 1px solid black"
                />
              </div> -->
              <div class="my-3">
                <h3>{{ $t("dashboard.img") }}</h3>
                <input
                  type="file"
                  id="src"
                  class="my-inp w-50"
                  style="border: 1px solid black"
                  accept="image/*"
                />
              </div>
              <div class="my-3">
                <button type="submit" class="add-btn">
                  {{ id == 0 ? $t("dashboard.add") : $t("dashboard.edit") }}
                </button>
              </div>
            </div>
          </form>
        </CardComponent>
      </div>
    </SideBar>
    <div class="popUp" :style="{ display: dis, zIndex: Zindex }">
      <div class="title">{{ $t("dashboard.loading") }}</div>
    </div>
  </div>
</template>

<script>
import SideBar from "@/components/AdminDashboard/SideBar.vue";
import CardComponent from "@/components/AdminDashboard/CardComponent.vue";
import router from "@/router";
import store from "@/store";
import axios from "axios";
export default {
  name: "add-plan",
  data() {
    return {
      bedroomsAR: "",
      bedroomsEN: "",
      spaceAR: "",
      spaceEN: "",
      rentStart: 0,
      id: 0,
      dis: "none",
      Zindex: -3,
    };
  },
  components: {
    SideBar,
    CardComponent,
  },
  methods: {
    addPlan() {
      if (
        this.bedroomsAR === "" ||
        this.bedroomsEN === "" ||
        this.spaceAR === "" ||
        this.spaceEN === ""
      ) {
        alert(
          this.$i18n.locale === "ar"
            ? "الرجاء تعبئة الحقول المطلوبة"
            : "Please fill all the required fields"
        );
        return;
      }

      const formData = new FormData();
      const imgFile = document.querySelector("#src");
      const imgFiles = imgFile.files;

      if (imgFiles.length == 0) {
        alert(
          this.$i18n.locale === "ar"
            ? "الرجاء إضافة صورة المخطط"
            : "Please add plan image"
        );
        return;
      }
      formData.append("image", imgFiles[0]);
      formData.append("bedrooms_ar", this.bedroomsAR);
      formData.append("bedrooms_en", this.bedroomsEN);
      formData.append("space_ar", this.spaceAR);
      formData.append("space_en", this.spaceEN);
      formData.append("rent_start", this.rentStart);

      this.dis = "block";
      this.Zindex = 10;

      const token = store.state.token;
      if (!token) {
        alert("Token is missing");
        this.dis = "none";
        this.Zindex = -3;
        return;
      }

      axios
        .post(store.state.server + "add-plan", formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.status === 200) {
            alert("تمت الإضافة بنجاح");
            this.dis = "none";
            this.Zindex = -3;
            router.push("/admin-plans");
          }
        })
        .catch((error) => {
          console.log(error);
          this.dis = "none";
          this.Zindex = -3;
        });
    },
    editPlan() {
      if (
        this.bedroomsAR === "" ||
        this.bedroomsEN === "" ||
        this.spaceAR === "" ||
        this.spaceEN === ""
      ) {
        alert(
          this.$i18n.locale === "ar"
            ? "الرجاء تعبئة الحقول المطلوبة"
            : "Please fill all the required fields"
        );
        return;
      }

      const formData = new FormData();
      const imgFile = document.querySelector("#src");
      const imgFiles = imgFile.files;

      if (imgFiles.length > 0) {
        formData.append("image", imgFiles[0]);
      }
      formData.append("bedrooms_ar", this.bedroomsAR);
      formData.append("bedrooms_en", this.bedroomsEN);
      formData.append("space_ar", this.spaceAR);
      formData.append("space_en", this.spaceEN);
      formData.append("rent_start", this.rentStart);

      this.dis = "block";
      this.Zindex = 10;

      const token = store.state.token;
      if (!token) {
        alert("Token is missing");
        this.dis = "none";
        this.Zindex = -3;
        return;
      }

      axios
        .post(store.state.server + "update-plan/" + this.id, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.status === 200) {
            alert("تم التعديل بنجاح");
            this.dis = "none";
            this.Zindex = -3;
            router.push("/admin-plans");
          }
        })
        .catch((error) => {
          console.log(error);
          this.dis = "none";
          this.Zindex = -3;
        });
    },
    getData() {
      axios
        .get(store.state.server + "get-plan/" + this.id)
        .then((response) => {
          this.bedroomsAR = response.data.bedrooms_ar;
          this.bedroomsEN = response.data.bedrooms_en;
          this.spaceAR = response.data.space_ar;
          this.spaceEN = response.data.space_en;
          this.rentStart = response.data.rent_start;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.get("id") !== null) {
      this.id = urlParams.get("id");
      this.getData();
    }
  },
};
</script>

<style scoped>
.popUp {
  height: 100dvh;
  width: 100dvw;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.3);
}

.title {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100dvh;
  width: 100dvw;
  font-size: 40px;
  font-weight: 700;
}
</style>
